import { DocumentRetrievalResult } from 'schemas/DocumentRetrievalResultSchema'
import { TimeZoneStrings } from 'enums/TimeZone'
import { getStreamDataFromDocument } from 'utils/streamDataUtil'

export const createStreamWidgetDataFromDocumentRetrieval = (
  searchResult: DocumentRetrievalResult,
  timeZone: TimeZoneStrings
) => {
  let deletedSentenceCount = 0
  let deletedSentenceDateRangeFrom: number | undefined
  let deletedSentenceDateRangeTo: number | undefined

  const { documents } = searchResult
  const soundbites = documents!.map((document) => {
    const streamData = getStreamDataFromDocument(
      document,
      timeZone,
      document.annotatedSentiment,
      true,
      true
    )
    return streamData
  })

  documents!
    .filter((document) => document.deleted)
    .forEach((document) => {
      deletedSentenceCount += 1

      if (
        !deletedSentenceDateRangeFrom ||
        Number(document.properties.datetime!) < deletedSentenceDateRangeFrom
      ) {
        deletedSentenceDateRangeFrom = Number(document.properties.datetime!)
      }

      if (
        !deletedSentenceDateRangeTo ||
        Number(document.properties.datetime!) > deletedSentenceDateRangeTo
      ) {
        deletedSentenceDateRangeTo = Number(document.properties.datetime!)
      }
    })

  return {
    soundbites,
    deletedSentenceCount,
    deletedSentenceDateRangeFrom,
    deletedSentenceDateRangeTo
  }
}

export default createStreamWidgetDataFromDocumentRetrieval
